require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/array/from.js
// module id = 52
// module chunks = 0